// assets
import tokenIcon from '../../../../assets/system/icons/pullvault-token.png';

// styles
import {
  TokenTierCardContainer,
  CardContentContainer,
  Price,
  TokenRow,
  TokenImg,
  TokenText,
  BtnContainer
} from './TokenTierCard.styles';

// components
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn';

  
export default function TokenTierCard({ title, price, description, isSelected = false, onSelect }) {
  return (
    <TokenTierCardContainer 
      className={`widget-bg ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <CardContentContainer>
        <h2>{title.toUpperCase()}</h2>
        <Price>${price}</Price>
        <TokenRow>
          <TokenImg src={tokenIcon} alt="token" />
          <TokenText>{description}</TokenText>
        </TokenRow>
      </CardContentContainer>

      <BtnContainer>
        <PrimaryBtn 
          title={isSelected ? "SELECTED" : "PURCHASE"}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            onSelect && onSelect();
          }}
        />
      </BtnContainer>
    </TokenTierCardContainer>
  );
} 